import * as React from 'react';

import { TUseItemDataOptions } from '@/shared/components/ui/form/components/searchable-select/components/list-box/hooks/use-item-data/use-item-data.types';

export const useItemData = ({ children }: TUseItemDataOptions) => {
  const itemData: React.ReactElement[] = [];

  (children as React.ReactElement[]).forEach(
    (
      item: React.ReactElement & {
        children?: React.ReactElement[];
      },
    ) => {
      itemData.push(item);
      itemData.push(...(item.children || []));
    },
  );

  return itemData;
};
